const workspaceRoutes = {
  path: "workspace",

  // Lazy-load the layout
  lazy: async () => {
    const mod = await import("components/UI/WorkspaceLayout");
    const WorkspaceLayout = mod.default;
    return { Component: WorkspaceLayout };
  },

  children: [
    {
      index: true,
      lazy: async () => {
        const mod = await import("views/Admin/Workspace");
        const Workspace = mod.default;
        return { Component: Workspace };
      },
    },
    {
      path: "details/:documentId",
      lazy: async () => {
        const mod = await import(
          "views/Admin/Workspace/WorkspaceDocumentDetails"
        );
        const WorkspaceDocumentDetails = mod.default;
        return { Component: WorkspaceDocumentDetails };
      },
    },
    {
      path: "media-assets",
      lazy: async () => {
        const mod = await import("views/Admin/Workspace/MediaAssets");
        const MediaAssets = mod.default;
        return { Component: MediaAssets };
      },
    },
  ],
};

export default workspaceRoutes;
